import React from 'react';
import { Alert } from 'reactstrap';

export default function LeadsError({ error }) {
  if (!error) return null;
  return (
    <Alert color="danger">
      { error }
    </Alert>
  );
}
